import { useMessagingStore } from '@/store/messaging.store';
import { useUnreadSummary } from '@/hooks/useMessages';

import FaIcon from '../common/FaIcon';

interface MessagingToggleProps {
  className?: string;
}

export function MessagingToggle({ className }: MessagingToggleProps) {
  const { togglePanel, isPanelOpen } = useMessagingStore();
  const { data: unreadData } = useUnreadSummary();

  const totalUnread = unreadData?.total_unread || 0;

  return (
    <button
      type="button"
      onClick={togglePanel}
      // aria-label overrides the descendant badge, so the unread count has to be
      // spelled into the name or it is announced to nobody.
      aria-label={totalUnread > 0 ? `Messages, ${totalUnread} unread` : 'Messages'}
      aria-expanded={isPanelOpen}
      title="Messages"
      className={`relative ${className || `p-2 rounded-lg transition-colors ${
        isPanelOpen
          ? 'bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400'
          : 'text-gray-600 dark:text-gray-300'
      }`}`}
    >
      <FaIcon icon="comment-dots" className="h-5 w-5" />
      {/* Unread badge */}
      {totalUnread > 0 && (
        <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-xs font-bold rounded-full pointer-events-none">
          {totalUnread > 99 ? '99+' : totalUnread}
        </span>
      )}
    </button>
  );
}
